// = require funding/funding

angular.module('filters.funding', [])

  .filter('displayReportValue', function() {
    return function displayValue(report) {
      return devex.funding.displayReportValue(report);
    };
  })

  .filter('displayLeadFunderName', function() {
    return function(donors) {
      if(donors.length) {
        return donors[0].name;
      }
    };
  })

  .filter('getSupportingFunderNames', function() {
    return function(donors) {
      if(donors.length && donors.length > 1) {
        return donors
          .slice(1) // Exclude lead funder from donors list
          .map(function(donor){
            return donor.name;
          });
      }
    };
  })

  .filter('titleDisplay', function () {
    return function(title) {
      return devex.funding.titleDisplay(title);
    };
  });
